// AUTO-GENERATED - DO NOT EDIT MANUALLY

import {
  AchievementReturnDto,
  UserDeleteDto,
  UserReturnDto,
  UserUpdateDto,
  UserUpdatePasswordDto,
  IBaseArrayResultDto,
  IBaseSingleResultDto,
} from '@skillarea/lib-shared';

import { IRequestOptions, IRequestConfig, getConfigs, axios } from './options';

export const basePath = '';

export class UserService {
  /**
   * GET /api/user/self
   */
  self(
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<UserReturnDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/self';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * PUT /api/user/self
   */
  updateSelf(
    params: {
      /** requestBody */
      body?: UserUpdateDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<UserReturnDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/self';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * PUT /api/user/password
   */
  updatePassword(
    params: {
      /** requestBody */
      body?: UserUpdatePasswordDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/password';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * DELETE /api/user/self
   */
  deleteSelf(
    params: {
      /** requestBody */
      body?: UserDeleteDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/self';

      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * GET /api/user/achievements
   */
  achievements(
    options: IRequestOptions = {},
  ): Promise<IBaseArrayResultDto<AchievementReturnDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/achievements';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }
}
